import { DailyNavRecord } from 'api/models/DailyNavRecord';

export const DAILY_NAV_SPREADSHEET_NAME = 'daily-nav-spreadsheet';
export const DAILY_NAV_SPREADSHEET_TITLE = 'Company';
export const DAILY_NAV_SPREADSHEET_TITLE_ALIAS = 'title';
export const DAILY_NAV_SPREADSHEET_SECTIONS_ALIAS = 'sections';

export const DAILY_NAV_COLUMN_TYPES = {
  VALUATION_DATE: 'valuation_date',
  EQUITY_VALUE: 'equity_value',
  PRICE_PER_SHARE: 'price_per_share',
  STATUS: 'status',
} as const;

export const DAILY_NAV_COLUMN_ORDER = [
  DAILY_NAV_COLUMN_TYPES.VALUATION_DATE,
  DAILY_NAV_COLUMN_TYPES.EQUITY_VALUE,
  DAILY_NAV_COLUMN_TYPES.PRICE_PER_SHARE,
  DAILY_NAV_COLUMN_TYPES.STATUS,
];

export const DAILY_NAV_COLUMN_LABELS: Record<string, string> = {
  [DAILY_NAV_COLUMN_TYPES.VALUATION_DATE]: 'Valuation Date',
  [DAILY_NAV_COLUMN_TYPES.EQUITY_VALUE]: 'Equity Value',
  [DAILY_NAV_COLUMN_TYPES.PRICE_PER_SHARE]: 'Price / Share',
  [DAILY_NAV_COLUMN_TYPES.STATUS]: 'Status',
};

// Column-group bands rendered above the column labels, mirroring the monitoring
// prototype's PREVIOUS VALUATION / NAV CONSIDERATIONS sections.
export interface DailyNavSection {
  label: string;
  columnTypes: string[];
}

export const DAILY_NAV_SECTIONS: DailyNavSection[] = [
  {
    label: 'Previous Valuation',
    columnTypes: [
      DAILY_NAV_COLUMN_TYPES.VALUATION_DATE,
      DAILY_NAV_COLUMN_TYPES.EQUITY_VALUE,
      DAILY_NAV_COLUMN_TYPES.PRICE_PER_SHARE,
    ],
  },
  // Last Val Δ belongs to the prototype's Public Comp Market Cap section — add it back
  // there once public-comp data exists. Status is the only NAV Consideration for now.
  {
    label: 'NAV Considerations',
    columnTypes: [DAILY_NAV_COLUMN_TYPES.STATUS],
  },
];

// A record needs review until someone checks either review state in the Review
// Price dialog — "Reviewed by Scalar" or "Discussed with Fund". Saving alone (a
// note, a price-adjusted toggle, a status change) does not clear the warning; an
// explicit human sign-off does. The Status column's button styling keys off this.
export const dailyNavRecordNeedsReview = (record: DailyNavRecord): boolean =>
  !record.reviewed_by_scalar && !record.discussed_with_fund;

export const REVIEW_PRICE_LABEL = 'Review Price';

// Report-date query param. Deliberately distinct from the shared 'date' param, which
// Intelligence's measurement-date filter owns; NAV dates are free-standing daily values.
export const DAILY_NAV_REPORT_DATE_PARAM = 'nav_date';
